export const regex = {
  time: /^time-[\d.]+$/,
  grow: /^grow-{0,1}(left|right|up|down|center){0,1}$/,
  slide: /^slide-(left|right|up|down)$/,
  flip: /^flip-(left|right|up|down)$/,
  spin: /^-{0,1}spin-[\d.]+$/,
  scramble: /^scramble$/,
  typing: /^typing$/,
  blur: /^blur-in$/,
  bounce: /^bounce-in$/,
  fly: /^fly-in$/
};

const validate = (s?: string) =>
  s
    ?.trim()
    .split(/\s+/)
    .every(s => Object.values(regex).some(r => r.test(s)));

export default validate;
